const isChecked = (value) => {
  if (typeof (value) === 'string' || Array.isArray(value)) {
    return value.length > 0;
  }
  return !!value;
};

export default isChecked;
